
import React from 'react';
import { QuickActionButton } from './QuickActionButton';
import { QuickActionData } from '@/types/crm';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { PlusCircle, CalendarPlus, Send, FileText, UserPlus, Phone } from 'lucide-react';

const actionsData: QuickActionData[] = [
  { title: 'New Opportunity', description: 'Create a new sales opportunity', icon: PlusCircle, iconColor: 'text-blue-500', bgColor: 'bg-blue-100', href: '/opportunity/new' },
  { title: 'Schedule Meeting', description: 'Book a meeting with a prospect', icon: CalendarPlus, iconColor: 'text-green-500', bgColor: 'bg-green-100', href: '/meeting/new' },
  { title: 'Send Email', description: 'Send a follow-up email', icon: Send, iconColor: 'text-purple-500', bgColor: 'bg-purple-100', href: '/email/compose' }, // Placeholder href
  { title: 'Create Quote', description: 'Generate a new quote', icon: FileText, iconColor: 'text-orange-500', bgColor: 'bg-orange-100', href: '/quotes/new' }, // Placeholder href
  { title: 'Add Contact', description: 'Add a new contact', icon: UserPlus, iconColor: 'text-pink-500', bgColor: 'bg-pink-100', href: '/contact/new' },
  { title: 'Log Call', description: 'Record a phone call', icon: Phone, iconColor: 'text-teal-500', bgColor: 'bg-teal-100', href: '/calls/log' }, // Placeholder href
];

export const QuickActionsPanel: React.FC = () => {
  return (
    <Card className="mb-6">
      <CardHeader>
        <CardTitle className="text-lg">Quick Actions</CardTitle>
        <p className="text-sm text-muted-foreground">Common tasks to help you work more efficiently</p>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
          {actionsData.map((action) => (
            <QuickActionButton key={action.title} {...action} />
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

